import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Create, useGetOne } from 'react-admin';
import { transformCourseCityDates } from '../../helper/transform';
import { CourseCalendarForm } from './form/CourseCalendarForm';
import { CourseCalendarAside } from './partial/CourseCalendarAside';

export const CourseCalendar = (props) => {
  const { id } = useParams();
  const { data, isLoading } = useGetOne('courses', { id });

  if (isLoading) {
    return null;
  }

  return (
    <Create
      title={`${data.code} ${data.title}`}
      aside={<CourseCalendarAside course={data} />}
      resource={`courses/${data.originId}/calendar/create`}
      redirect={false}
      transform={(data) => transformCourseCityDates(data, true)}
    >
      <CourseCalendarForm course={data} {...props} />
    </Create>
  );
};
